import { LogLevel } from '@azure/msal-browser';

/**
 * MSAL Configuration for PolicyLens - Microsoft Entra External ID
 * Based on: https://learn.microsoft.com/en-us/entra/external-id/customers/tutorial-single-page-app-react-sign-in-prepare-app
 */
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: process.env.REACT_APP_AUTHORITY,
        redirectUri: process.env.REACT_APP_REDIRECT_URI || 'http://localhost:3000',
        postLogoutRedirectUri: '/',
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

/**
 * Scopes for login request.
 * For External ID (CIAM), we only request basic OIDC scopes during login.
 * The custom API scope is requested separately via acquireTokenSilent.
 */
export const loginRequest = {
    scopes: [],
};

/**
 * Scopes for acquiring access token to call the protected API.
 * This is used with acquireTokenSilent AFTER login succeeds.
 */
export const apiTokenRequest = {
    scopes: [process.env.REACT_APP_API_SCOPE],
};

/**
 * API base URL for the PolicyLens backend.
 */
export const apiConfig = {
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000',
};
